import i18n from "i18n";
import { translateServerMessage } from "i18n/serverMessages";
import { BaseError } from "errors/BaseError";

export default class HttpRequestError extends Error implements BaseError {
  public statusCode: number;

  constructor(m: string, statusCode: number) {
    super(m);
    this.statusCode = statusCode;
  }

  needAlert(): boolean {
    return true;
  }

  getMessage(): string {
    const def = this.getErrorDefaultText();
    if (def) return def;
    // サーバーは呼び手の言語を知らない（実測 2026-08-25）。
    //   受け取った日本語を 画面の言語へ置き換える。
    //   当てられなければ そのまま出す（消さない）。件数は missCount() で数えている。
    const swapped = translateServerMessage(this.message, i18n.language);
    return swapped || this.message;
  }

  private getErrorDefaultText() {
    switch (this.statusCode) {
      case 401:
        return i18n.t("common:httpError.unauthorized");
      case 402:
        // ★未払いで 止まっている時★（Payment Required）
        //
        // 此処が 無いと default に 落ち、止められたお客様に
        // 「ブラウザのキャッシュをクリアしてください」と 出ていた（2026-08-13 実測）。
        // 理由も 払い方も 伝わらず、リロードを 繰り返させることになる。
        //
        // ★既定文を 返すと サーバーの 文言が 捨てられる★（getMessage は 既定文を 優先する）。
        // ゆえに サーバーが 文言を 送っていれば 空を 返し、そのまま 出す。
        return this.message
          ? ""
          : i18n.t("payment:suspended.registerCard");
      case 404:
        return i18n.t("common:httpError.notFound");
      case 500:
        return i18n.t("common:httpError.serverError");
      case 400:
      default:
        return i18n.t("common:httpError.staleData");
    }
  }
}
